import slugify from '@@/js/utils/slugify';

// URL direction param format: `<code>-<slugified description>`.
// The leading integer is the canonical direction code, parsed back by
// getDirectionDetails() in stores/schedules.js — keep the two in sync.
export default function directionSlug(code, description) {
    return slugify(`${code}-${description}`);
}
